import {TrackableEntity} from './../data/ChangeTrackable';
import {AmsHts} from './AmsHts';
import {AmsHm} from './AmsHm';

export class AmsHbl extends TrackableEntity {
    id: number = 0;
    amsMasterId: number = 0;
    amsID: string = '';
    valueCargo: boolean = false;
    hblNo: string = '';
    itNo: string = '';
    vInbondNo: string = '';
    amsMblNo: string = '';
    mblNo: string = '';
    sName: string = '';
    sAddress1: string = '';
    sAddress2: string = '';
    sAddress3: string = '';
    sPhone: string = '';
    cName: string = '';
    cType: string = '';
    cAddress1: string = '';
    cAddress2: string = '';
    cAddress3: string = '';
    cPhone: string = '';
    nName: string = '';
    nAddress1: string = '';
    nAddress2: string = '';
    nAddress3: string = '';
    nPhone: string = '';
    bsName: string = '';
    bsAddress1: string = '';
    bsAddress2: string = '';
    bsAddress3: string = '';
    bsPhone: string = '';
    bcName: string = '';
    bcAddress1: string = '';
    bcAddress2: string = '';
    bcAddress3: string = '';
    bcPhone: string = '';
    bnName: string = '';
    bnAddress1: string = '';
    bnAddress2: string = '';
    bnAddress3: string = '';
    bnPhone: string = '';
    placeOfRec: string = '';
    dCode1: string = '';
    fDestPort: string = '';
    foreignDest: string = '';
    foreignPort: string = '';
    delivery: string = '';
    custRefNo: string = '';
    expRls: boolean = false;
    moveType: string = '';
    coLoadAms: boolean|null = null;
    coloadAmsBl: string = '';
    marks: string = '';
    description: string = '';
    hValue: number = 0;
    sPkgs: number = 0;
    spUnit: string = '';
    sWeight: number = 0;
    swUnit: string = '';
    sVolume: number = 0;
    svUnit: string = '';
    sValue: number = 0;
    caType: string = '';
    containerHId: number = 0;
    containerMId: number = 0;
    pkgs: number = 0;
    pUnit: string = '';
    weight: number = 0;
    wUnit: string = '';
    volume: number = 0;
    vUnit: string = '';
    value: number = 0;
    acctID: string = '';
    acDesc: string = '';
    preRevenue: number = 0;
    preCost: number = 0;
    colRevenue: number = 0;
    colCost: number = 0;
    crDate: string | null = null;
    created: string = '';
    modified: string = '';
    fPortName: string = '';
    dPortName1: string = '';
    hts: AmsHts[] = [];
    hm: AmsHm[] = [];

    constructor(init?:Partial<AmsHbl>) {
        super();
        this.key='id';
        Object.assign(this, init);
        if(this.id === 0) this.id = this.GetNextId();

        if(this.hts.length > 0) {
            this.hts = this.hts.map(d => new AmsHts(d));
        } else {
            this.hts = [];
        }
        if(this.hm.length > 0) {
            this.hm = this.hm.map(d => new AmsHm(d));
        } else {
            this.hm = [];
        }
    }
}
